// FlowNode_style.js
import { zoom, zoomBoxShadow, zoomBorder, getResponsiveZoom } from '../../zoomUtils.js';

export const flowNodeStyles = {
  base: {
    borderRadius: zoom('12px'),
    boxShadow: zoomBoxShadow('0 0 60px rgba(108, 163, 208, 0.35)'),
    background: 'radial-gradient(circle at center, rgba(0, 0, 0, 0.15) 30%, rgba(255, 255, 255, 0.02) 50%, rgba(255, 255, 255, 0.17) 110%)',
    backdropFilter: `blur(${zoom('2px')})`,
    WebkitBackdropFilter: `blur(${zoom('1.5px')})`,
    color: '#ADDAEF',
    textShadow: zoomBoxShadow('0 0 10px rgba(0, 0, 0, 0.2)'),
    border: zoomBorder('2px', 'solid', 'rgba(64, 230, 202, 0.2)'),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
    width: 'fit-content',
    height: 'fit-content',
    justifySelf: 'center',
    alignSelf: 'center'
  },

  intro: {
    borderRadius: '50%',
    fontSize: zoom('18px'),
    width: zoom('130px'),
    height: zoom('130px'),
    minWidth: zoom('130px'),
    maxWidth: zoom('130px'),
    minHeight: zoom('130px'),
    maxHeight: zoom('130px')
  },

  introMobile: {
    width: zoom('115px'),
    height: zoom('115px'),
    minWidth: zoom('115px'),
    maxWidth: zoom('115px'),
    minHeight: zoom('115px'),
    maxHeight: zoom('115px'),
    fontSize: zoom('16px')
  },

  textContainer: {
    padding: zoom('15px'),
    textAlign: 'center',
    fontWeight: 'bold'
  }
};

export const getFlowNodeStyles = (className = '', isPlainText = false) => {
  const { isMobile } = getResponsiveZoom();
  
  let styles = { ...flowNodeStyles.base };
  
  // Apply intro styles if className includes 'intro'
  if (className.includes('intro')) {
    styles = {
      ...styles,
      ...flowNodeStyles.intro,
      ...(isMobile ? flowNodeStyles.introMobile : {})
    };
  } else {
    // Scale regular nodes
    styles = {
      ...styles,
      fontSize: zoom('1em'),
      padding: `${zoom('12px')} ${zoom('18px')}`
    };
  }
  
  return styles;
};

export const getTextContainerStyles = () => {
  return flowNodeStyles.textContainer;
};